import { GridFilterModel, GridLinkOperator } from '@material-ui/data-grid'
import create from 'zustand'
import { persist } from 'zustand/middleware'

type MessageActions = {
  setFilter: (props: GridFilterModel) => void
  clearFilterRefsInteraction: () => void
}

type State = GridFilterModel & MessageActions

const initialState: GridFilterModel = { items: [] }

export const useFilterValidationStateRefsInteraction = create<State>(
  persist(
    (set) => ({
      ...initialState,
      setFilter: (props: GridFilterModel) => {
        set({ ...props, linkOperator: GridLinkOperator.And })
      },
      clearFilterRefsInteraction: () => {
        set({
          items: [],
        })
      },
    }),
    {
      name: 'validationFilterRefsInteractions',
    },
  ),
)
